import { useQuery } from '@tanstack/react-query'

import { getMerchantGeneralBlock } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMerchantGeneralBlockList = () => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () => getMerchantGeneralBlock(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_MERCHANT_GENERAL_BLOCK_LIST],
  })
}
